import {
  THOUGHT_LEADERSHIP,
  TOPIC,
  AUTHOR,
  PRODUCT_INSIGHTS,
  ACTIVE,
  ADVISOR,
  INVESTOR,
  WHOLESALER,
  SERVICE_LABEL_ADVISOR,
  SERVICE_LABEL_INVESTOR,
  SERVICE_LABEL_WHOLESALER,
} from './constants.js'

export function getActiveThoughtLeaderships(subscriptions) {
  return subscriptions
    .filter((subscription) => {
      return (
        subscription.category === THOUGHT_LEADERSHIP &&
        subscription.status === ACTIVE
      )
    })
    .sort((a, b) => {
      // Hardcoded order
      const list = [
        'Latest Insights',
        'Market Outlook',
        'Business Building Ideas',
        'Investor Newsletter',
      ]

      const aScore = list.indexOf(a.name)
      const bScore = list.indexOf(b.name)

      if (aScore > bScore) {
        return 1
      } else if (aScore < bScore) {
        return -1
      } else {
        return 0
      }
    })
}

export function getActiveTopics(subscriptions) {
  return subscriptions
    .filter((subscription) => {
      return subscription.category === TOPIC && subscription.status === ACTIVE
    })
    .sort(sortName)
}

export function getActiveAuthors(subscriptions) {
  return subscriptions
    .filter((subscription) => {
      return subscription.category === AUTHOR && subscription.status === ACTIVE
    })
    .sort(sortName)
}

export function getActiveProductResults(subscriptions) {
  return subscriptions
    .filter((subscription) => {
      return (
        subscription.category === PRODUCT_INSIGHTS &&
        subscription.status === ACTIVE
      )
    })
    .sort(sortName)
}

export function getSubscriptionsWithoutProductInsights(subscriptions) {
  return subscriptions
    .filter((subscription) => {
      return subscription.category !== PRODUCT_INSIGHTS
    })
    .sort(sortName)
}

function isAvailableForRole(availableRoles, userRole) {
  switch (userRole) {
    case SERVICE_LABEL_ADVISOR:
      return availableRoles.indexOf(ADVISOR) > -1
    case SERVICE_LABEL_INVESTOR:
      return availableRoles.indexOf(INVESTOR) > -1
    case SERVICE_LABEL_WHOLESALER:
      return (
        availableRoles.indexOf(INVESTOR) > -1 ||
        availableRoles.indexOf(WHOLESALER) > -1
      )
  }
}

function sortName(a, b) {
  const aName = a.name.toLowerCase()
  const bName = b.name.toLowerCase()

  if (aName > bName) {
    return 1
  } else if (aName < bName) {
    return -1
  } else {
    return 0
  }
}

export function getSubscriptionColumns(subscriptions, columnSize) {
  const subscriptionColumns = []

  const _subscriptions = subscriptions.sort((a, b) =>
    (a.name || '').localeCompare(b.name || '', 'en', { sensitivity: 'base' })
  )

  if (columnSize === 0) {
    return _subscriptions
  }

  _subscriptions.map((subscription, i) => {
    const newTopicIndex = Math.floor(i / columnSize)

    if (i % columnSize === 0) {
      subscriptionColumns[newTopicIndex] = []
    }

    subscriptionColumns[newTopicIndex].push(subscription)
  })

  return subscriptionColumns
}

export function updateSubscriptionData(
  userSubscriptionProfile,
  subscriptionData
) {
  const allSubscribed = getAllSubscriptionsFromSubscriptionProfile(
    userSubscriptionProfile
  )
  const updatedSubscriptions = []

  const isSubscribed = (subscription) => {
    let isChecked = false
    allSubscribed.map((userSubscription) => {
      if (userSubscription.status === 'Active') {
        if (userSubscription.publication) {
          if (subscription.id === userSubscription.publication.publicationID) {
            isChecked = true
          }
        }
      }
    })
    return isChecked
  }

  subscriptionData.subscriptions.map((subscription) => {
    subscription.checked = isSubscribed(subscription)
    const isRole = isAvailableForRole(
      subscription.availableRoles,
      userSubscriptionProfile?.role
    )
    if (isRole) {
      updatedSubscriptions.push(subscription)
    }
  })

  return updatedSubscriptions
}

export function updateFundData(funds, userSubscriptionProfile) {
  const isLiteratureSelected = (userSubscriptionProfile, id) => {
    const allSubscribed = getAllSubscriptionsFromSubscriptionProfile(
      userSubscriptionProfile
    )
    let found = false

    allSubscribed.map((userSubscription) => {
      if (
        userSubscription.status === 'Active' &&
        userSubscription?.publication?.publicationID === id
      ) {
        found = true
      }
    })

    return found
  }

  const getActiveLiterature = (literature, userSubscriptionProfile) => {
    return literature?.filter((doc) => {
      const isRole = isAvailableForRole(
        doc.availableRoles,
        userSubscriptionProfile?.role
      )

      return doc.active && isRole
    })
  }

  const _funds = [...funds]

  _funds &&
    _funds.forEach((fund) => {
      if (fund) {
        fund.activeLiterature = getActiveLiterature(
          fund.literature,
          userSubscriptionProfile
        )

        fund.literature &&
          fund.literature.forEach((doc) => {
            doc.selected = isLiteratureSelected(userSubscriptionProfile, doc.id)
            doc.preSelected = doc.selected
          })

        fund.literature = null
      }
    })

  return _funds
}

export function getFundsByProductType(funds, productType) {
  return funds.filter((fund) => {
    if (fund.productType === productType) {
      return fund
    }
  })
}

export function getSubscribedLiteratureForFunds(fund) {
  return fund.activeLiterature.filter((doc) => {
    return doc.selected
  })
}

export function findFundById(funds, id) {
  return funds.find((fund) => fund.id === id)
}

export function findLiteratureById(literatureList, id) {
  return literatureList.find((doc) => doc.id === id)
}

export function setSelectedFund(funds, id) {
  funds &&
    funds.forEach((fund) => {
      fund.selected = fund.id === id
    })
}

export function getAllSubscriptionsFromSubscriptionProfile(
  subscriptionProfile
) {
  const allSubscribed = []

  subscriptionProfile?.subscriptionsData?.forEach((pubType) => {
    pubType.subscriptions.forEach((sub) => {
      allSubscribed.push(sub)
    })
  })

  return allSubscribed
}

export function findSubscriptionFromSubscriptionListByPublicationID(
  subscriptions,
  publicationID
) {
  return subscriptions.find((_subscription) => {
    let found = false
    if (_subscription.publication) {
      if (publicationID === _subscription.publication.publicationID) {
        found = true
      }
    }

    if (_subscription.publication) {
      if (publicationID === _subscription.publication.publicationID) {
        found = true
      }
    }
    return found
  })
}

export function getWholesalerLabel(wholesalerLabels, labelToFind) {
  return (
    wholesalerLabels &&
    wholesalerLabels.length > 0 &&
    (
      wholesalerLabels.find((label) => label.key === labelToFind) || {
        label: '',
      }
    ).label
  )
}
